export default __webpack_public_path__ + "static/media/funnel.dd00d2e1.svg";